export const RegionCodes = Object.freeze({
  US: 'us',
  EU: 'eu',
  AU: 'au'
});

const region_code_key = 'GoformzRegionCode';
export function InitializeRegion() {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const regionCodeFromQuery = params.get('regionCode');
  if (!!regionCodeFromQuery) {
    localStorage.setItem(region_code_key, regionCodeFromQuery);
  }

  const existingRegionCode = getRegionCode();
  if (!!existingRegionCode) {
    return;
  }

  //default to storing the us
  localStorage.setItem(region_code_key, RegionCodes.US);
}

export function getRegionCode() {
  return localStorage.getItem(region_code_key) || RegionCodes.US;
}
